export const NavMobileSidebar = {
  transclude: true,

  bindings: {
    heading: '@',
    isActive: '<',
    onClick: '&',
  },

  template: `
    <nav class="nav-mobile-sidebar"
      ng-class="{ 'sidebar--show' : $ctrl.isActive }">
      <div class="navbar-sidebar-content p-3 p-md-0 bg-whitesmoke">
        <div class="d-flex d-md-none pb-2 border border-bottom">
          <strong class="mr-auto">
            <i class="fa fa-sliders"></i>
            {{ $ctrl.heading }}
          </strong>
          <button class="btn btn-link p-0 d-inline-flex"
            ng-click="$ctrl.onClick()">
            Done
          </button>
        </div>
        <ng-transclude></ng-transclude>
      </div>
      <div class="navbar-sidebar-overlay bg-black-opaque"
        ng-click="$ctrl.onClick()">
      </div>
    </nav>`,
};



// WEBPACK FOOTER //
// ./src/components/Nav/NavMobileSidebar.js